import range from 'lodash/range'
import moment from 'moment-timezone'
import {Dropdown} from '@freckle/educator-materials/ts/components/dropdown'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {flatOptions} from '@freckle/educator-materials/ts/logic/dropdown'
import {filterWrapper} from './style.module.scss'

type Props = {
  onChange: (year: number) => void
  value: number
}

const YEAR_OF_FIRST_FRECKLE_COMMIT = 2012

export function YearPicker({onChange, value}: Props) {
  const {t} = useSafeTranslation()
  const currentYear = moment().year()
  const years = range(currentYear, YEAR_OF_FIRST_FRECKLE_COMMIT - 1)

  const mkOption = (year: number) => ({label: year.toString(), value: year})

  const items = years.map(mkOption)

  return (
    <div id="year-picker-dropdown" className={filterWrapper}>
      <Dropdown
        labelText={t('ASSESSMENTS_PAGE_YEAR_PICKER_LABEL')}
        value={mkOption(value)}
        dataTest="year-picker-dropdown"
        handleChange={input => {
          if (input === null) return
          onChange(input.value)
        }}
        options={flatOptions<number>(items)}
      />
    </div>
  )
}
